export default __webpack_public_path__ + "static/media/mobile_modal_close.9bcc9c44.svg";